import Vue from 'vue'
import env from '../../../config/prod.env.js'

const state = {
  weeklyEvaluations: [],
  evaluationQuestions: [],
  evaluationExtQuestions: [],
  answeredEvaluation: {},
  personalDevelopments: []
}

const mutations = {  
  SET_WEEKLY_EVALUATIONS (state, payload) {
    state.weeklyEvaluations = payload
  },
  SET_EVALUATION_QUESTIONS (state, payload) {
    state.evaluationQuestions = payload
  },
  SET_EXT_EVALUATION_QUESTIONS (state, payload) {
    state.evaluationExtQuestions = payload
  },
  SET_ANSWERED_EVALUATION (state, payload) {
    state.answeredEvaluation = payload
  },
  SET_PERSONAL_DEVELOPMENTS (state, payload) {
    state.personalDevelopments = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  }
}

const actions = {
  actualWeekEvaluations: (context, consultant) => {
    return Vue.http.get(`${env.API}/api/guideline-answered/actual-week-evaluations/${consultant}`)    
      .then((response) => {        
        context.commit('SET_WEEKLY_EVALUATIONS', response.body.evaluatedUsers)
        return response.body.evaluatedUsers
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getEvaluationQuestions: (context, type) => {
    return Vue.http.get(`${env.API}/api/guideline/${type}`)    
      .then((response) => {        
        context.commit('SET_EVALUATION_QUESTIONS', response.body.guidelines)
        return response.body.guidelines
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  answerGuideline: (context, data) => {
    const { consultant_user, user_evaluated, collab_involve, body } = data
    return Vue.http.post(`${env.API}/api/guideline-answered/new/${consultant_user}/${user_evaluated}/${collab_involve}`, body)    
      .then((response) => {        
        return response.body.success
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getAnsweredEvaluation: (context, data) => {
    const { type, id } = data
    return Vue.http.get(`${env.API}/api/guideline-answered/history/${id}/${type}`)    
      .then((response) => {        
        context.commit('SET_ANSWERED_EVALUATION', response.body.guidelinesAnswered)
        return response.body.guidelinesAnswered
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getAnsweredGuidelinesInWeekRange: (context, data) => {
    const { user_evaluated, year } = data
    return Vue.http.get(`${env.API}/api/guideline-answered/by-week/${user_evaluated}/${year}`)    
    .then(response => {        
      return response.body.guidelinesAnswered
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  reportWeekEvaluations: (context, data) => {
    const { week, year } = data
    return Vue.http.get(`${env.API}/api/guideline-answered/report-week-evaluations/${week}/${year}`)    
      .then((response) => {                
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  persDeveByPlanCon: (context, data) => {    
    return Vue.http.post(`${env.API}/api/personal-development-con/by-plan-con-all`, data)    
      .then((response) => {
      context.commit('SET_PERSONAL_DEVELOPMENTS', response.body.message)               
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  persDeveByPlanConOpen: (context, data) => {    
    return Vue.http.post(`${env.API}/api/personal-development-con/by-plan-con`, data)    
      .then((response) => {
      context.commit('SET_PERSONAL_DEVELOPMENTS', response.body.message)               
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getAnsweredGuidelinesHistory: (context, data) => {
    const { user_evaluated, year, month } = data
    return Vue.http.get(`${env.API}/api/guideline-answered/collabs-history-information/${user_evaluated}/${year}/${month}`)    
    .then(response => {   
      return response.body
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  getLastWeekHistory: (context, data) => {
    const { user_id, type } = data
    return Vue.http.get(`${env.API}/api/guideline-answered/last-weeks-history/${user_id}/${type}`)    
    .then(response => {  
      return response.body
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  revalReport: (context, data) => {
    return Vue.http.post(`${env.API}/api/guideline-answered/answers-report`, data)    
      .then((response) => {             
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getEvaluationQuestionsByCategory: (context) => {
    return Vue.http.get(`${env.API}/api/guideline/guideline/by/category`)    
      .then((response) => {        
        context.commit('SET_EXT_EVALUATION_QUESTIONS', response.body.message)
        return response.body.guidelines
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
}

const getters = {
  getWeeklyEvaluations: (state) => state.weeklyEvaluations,
  getGuidelines: (state) => state.evaluationQuestions,
  getExtGuidelines: (state) => state.evaluationExtQuestions,
  getAnsweredEvaluation: (state) => state.answeredEvaluation,
  getPersonalDevelopments: (state) => state.personalDevelopments
}
export const consultant = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/consultant.js